<template>
  <div>
    <div
      style="font-size: 32px;
    color: #12aba3;
    position: absolute;
    font-weight: 600;
    margin-top: -5px;"
    >
      {{ $t('src/components/training/trainingecg.9764', { '1': this.currentHR }) }}
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="dropdown-container">
        <base-dropdown-select
          :options="listScaleX"
          v-model="scaleX"
          class="dropdown-min-select wider index"
        ></base-dropdown-select>

        <base-dropdown-select
          :options="listScaleY"
          v-model="scaleY"
          class="dropdown-min-select index"
        ></base-dropdown-select>
        <base-dropdown-select
          v-if="moduleInstance && isChangeECG"
          :options="listChannel"
          v-model="nChannel"
          class="dropdown-min-select wider index"
        ></base-dropdown-select>
      </div>
    </div>
    <div id="canvas-conteiner" class="canvas-conteiner">
      <canvas class="myCanvas" id="myCanvas"></canvas>
      <canvas class="canvas-ruler" id="canvasTime"></canvas>
      <canvas class="canvas-ruler" id="canvasEcg"></canvas>
    </div>
  </div>
</template>

<script>
import getSignal from '@/modules/ecg-viewer-real-time.js'
import('@/styles/components/chart.less')
import { subscribeMobileECG } from '@/mixins/subscribe-mobile-ecg.js'
import { wasmFilter } from '@/mixins/wasm-filter.js'
import dotnet from '@/assets/dotnet/dotnet.js'

export default {
  name: 'TrainingEcgRealTime',
  components: {
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue')
  },
  mixins: [subscribeMobileECG, wasmFilter],
  props: {
    currentHR: {
      type: Number,
      required: false
    }
  },
  data: function() {
    return {
      time: 0,
      maxY: [],
      minY: [],
      lastData: [],
      listScaleX: {
        25: `25 ${this.$t('unit.mm/s')}`,
        50: `50 ${this.$t('unit.mm/s')}`,
        75: `75 ${this.$t('unit.mm/s')}`,
        100: `100 ${this.$t('unit.mm/s')}`
      },
      scaleX: '25',
      listScaleY: {
        10: `10 ${this.$t('unit.mm/mv')}`,
        20: `20 ${this.$t('unit.mm/mv')}`,
        40: `40 ${this.$t('unit.mm/mv')}`,
        80: `80 ${this.$t('unit.mm/mv')}`
      },
      scaleY: '10',
      localBuffer: [],
      localBufferNotFilter: [],
      moduleInstance: null,
      source: null,
      dest: null,
      pointOfTime: [],
      mappedId: null,
      leadscount: null,
      nChannel: '1',
      generalLeads: null,
      titleSignals: ['I', 'II', 'III', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'],
      coordinateGraph: [],
      countPoint: 0,
      animationId: null,
      dotnet: null,
      initFilters: null,
      doFilter: null,
      coefX: 2,
      nbOfSamples: null,
      loaded: true,
      drawLoading: false,
      indexFilter: null
    }
  },
  watch: {
    scaleX() {
      this.countPoint = 0
      this.time = 0
      this.createCanvas()
    },
    scaleY() {
      this.countPoint = 0
      this.setScaleY()
      this.time = 0
      this.ctxEcg.clearRect(0, 0, this.canvasEcg.width, this.canvasEcg.height)
      this.createCanvas()
    },
    nChannel() {
      this.countPoint = 0
      this.coordinateGraph = []
      if (+this.nChannel === this.generalLeads + 1) {
        this.leadscount = this.generalLeads
      } else this.leadscount = 1
      this.source && this.freeBuffer(this.source)
      this.dest && this.freeBuffer(this.dest)
      this.source = this.allocArray(this.leadscount * this.nbOfSamples)
      this.dest = this.allocArray(this.leadscount * this.nbOfSamples)
      this.indexFilter = this.initFilters(
        this.nbOfSamples * this.leadscount,
        this.leadscount,
        this.nbOfSamples
      )
      this.time = 0
      this.ctxEcg.clearRect(0, 0, this.canvasEcg.width, this.canvasEcg.height)
      this.localBuffer = []
      this.createCanvas()
    },
    coordinateGraph() {
      for (let i = 0; i < this.coordinateGraph.length; i++) {
        this.ctx.font = '16px Arial'
        this.ctx.fillStyle = 'rgb(28, 179, 170)'
        this.ctx.fillText(`${this.titleSignals[i]}`, 30, this.coordinateGraph[i])
      }
    }
  },
  computed: {
    trainingId() {
      return this.$route.params.id
    },
    listChannel() {
      let opt = {}

      for (let i = 0; i < this.generalLeads; i++) {
        opt[i + 1] = `ECG ${this.titleSignals[i]}`
      }
      if (this.generalLeads > 1) {
        opt[this.generalLeads + 1] = this.$t('role.all')
      }
      return opt
    },
    isChangeECG() {
      return this.generalLeads && this.generalLeads > 2
    }
  },
  mounted() {
    window.onbeforeunload = function() {
      return
    }

    let promiseWasmFilter = new Promise(resolve => {
      this.dotnet = dotnet
      if (this.dotnet.getBootStatus() === 'Standby') {
        this.dotnet.boot()
      }
      resolve(this.dotnet)
    })

    promiseWasmFilter
      .then(dotnet => {
        let globalThis = require('globalthis/polyfill')() // returns native globalThis if compliant
        this.moduleInstance = globalThis.Module
        this.initFilters = dotnet.WasmFilter.initFilters
        this.doFilter = dotnet.WasmFilter.doFilters
      })
      .then(() => {
        this.loaded = false
      })
      .then(() => {
        this.canSubscribe = true
      })

    let self = this
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        if (self.localBuffer[0].length >= 7) {
          for (let i = 0; i < self.localBuffer.length; i++) {
            self.localBuffer[i].splice(0, self.localBuffer[i].length - 4)
          }

          self.time = 0
          self.ctxEcg.clearRect(0, 0, self.canvasEcg.width, self.canvasEcg.height)
        }
      }
    })
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId)
    console.log('beforeDestroy', this.source)
    this.source && this.freeBuffer(this.source)
    this.dest && this.freeBuffer(this.dest)
  },
  methods: {
    createCanvas() {
      this.canvas = document.getElementById('myCanvas')
      this.ctx = this.canvas.getContext('2d')

      this.canvasTime = document.getElementById('canvasTime')
      this.ctxTime = this.canvasTime.getContext('2d')

      this.canvasEcg = this.canvasEcg ? this.canvasEcg : document.getElementById('canvasEcg')
      this.ctxEcg = this.ctxEcg ? this.ctxEcg : this.canvasEcg.getContext('2d')
      let width = (this.canvas.width = this.canvasEcg.width = this.canvasTime.width =
        this.$el.clientWidth - 7)
      let tempHeight = 0
      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        tempHeight =
          tempHeight + (this.maxY[leadNumber] - this.minY[leadNumber]) * 4000 * +this.scaleY + this.scaleY * 6
      }
      tempHeight + 25
      let height = (this.canvas.height = this.canvasEcg.height = this.canvasTime.height = tempHeight) //350 * this.scaleY)//
      if (height <= 500) {
        document.getElementById('canvas-conteiner').style.height = 'auto'
      } else {
        document.getElementById('canvas-conteiner').style.height = `500px`
      }
      this.drawGrid(width, height)
    },
    drawGrid(width, height) {
      let d = 20
      let offsetx = 0
      let offsety = 0

      // Рисуем вертикальную сетку
      for (let i = 0; i <= width / d; i++) {
        this.ctx.strokeStyle = 'rgba(255,0,0,.2)'
        this.ctx.lineWidth = 1
        this.ctx.beginPath()
        this.ctx.moveTo(i * d + offsetx + 0.5, offsety)
        this.ctx.lineTo(i * d + offsetx + 0.5, height + offsety)
        this.ctx.stroke()
      }
      // Рисуем горизонтальную сетку
      for (let j = 0; j <= height / d; j++) {
        this.ctx.strokeStyle = 'rgba(255,0,0,.2)'
        this.ctx.lineWidth = 1
        this.ctx.beginPath()
        this.ctx.moveTo(offsetx, j * d + offsety + 0.5)
        this.ctx.lineTo(width - offsetx, j * d + offsety + 0.5)
        this.ctx.stroke()
      }

      this.ctx.fillStyle = 'rgba(255,0,0,.5)'
      // Рисуем промежуточные точки
      for (let i = 0; i <= width / 4; i++) {
        for (let j = 0; j <= height / 4; j++) {
          let x = offsetx + i * 4
          let y = j * 4
          if (x % 10 !== 0 && y % 10 !== 0) {
            this.ctx.fillRect(offsetx + i * 4, j * 4, 1, 1)
          }
          if ((x - offsetx == 0 || (x - offsetx) % 100 == 0) && (y === 0 || y % 100 == 0)) {
            let xPoint = offsetx + (i * (4 * this.scaleX)) / 25
            let yPoint = (j * (4 * this.scaleY)) / 10

            this.ctx.fillRect(xPoint - 0.5, yPoint - 0.5, 2, 2)
            this.ctx.font = '15px Arial'
            if (j === 0) {
              this.pointOfTime.push(xPoint)
            }
          }
        }
      }

      this.ctxEcg.lineWidth = 1
      this.ctxEcg.strokeStyle = 'rgb(79, 79, 79)'
    },
    timeString(sec) {
      sec = Math.round(sec)
      if (sec < 60) {
        return sec
      } else {
        return Math.floor(sec / 60) + ':' + (sec % 60 < 10 ? '0' + (sec % 60) : sec % 60)
      }
    },
    setScaleY() {
      let chartY = 30 * this.scaleY
      if (chartY <= 500) {
        document.getElementById('canvas-conteiner').style.height = 'auto'
      } else {
        document.getElementById('canvas-conteiner').style.height = `500px`
      }
    },
    changeDataByECG(signal) {
      let signalFB = getSignal(signal.signal)
      let packageId = signalFB.id()

      localStorage.setItem(`lastDataTime${this.trainingId}`, signalFB.timestamp())
      this.nbOfSamples = signalFB.readingscount() / signalFB.leadscount()
      if (packageId < this.mappedId) {
        return
      }

      if (!this.leadscount) {
        this.generalLeads = signalFB.leadscount()
        this.leadscount = signalFB.leadscount() > 2 ? 1 : signalFB.leadscount()

        if (!this.source) {
          try {
            this.source = this.allocArray(this.leadscount * this.nbOfSamples)
            this.dest = this.allocArray(this.leadscount * this.nbOfSamples)
            this.indexFilter = this.initFilters(
              this.nbOfSamples * this.leadscount,
              this.leadscount,
              this.nbOfSamples
            )
          } catch {
            cancelAnimationFrame(this.animationId)
            this.canSubscribe = false
            this.$emit('reload:ecg')
          }
        }

        this.coefX = (250 / this.nbOfSamples) * 4
      }
      this.countPoint += this.nbOfSamples
      let localSignal = []

      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        localSignal[leadNumber] = []
        let id = this.leadscount == this.generalLeads ? leadNumber : +this.nChannel - 1
        for (let i = 0; i < signalFB.ecgdata(id).ecgdataLength(); i++) {
          localSignal[leadNumber].push(signalFB.ecgdata(id).ecgdata(i))
        }
      }

      let ecgSignalsJointInOneArray = []
      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        ecgSignalsJointInOneArray.push(...localSignal[leadNumber])
      }

      let objJointSignalsEcgWithId = {
        id: packageId,
        signals: ecgSignalsJointInOneArray
      }

      let minBeforeCurrentIndex = 0
      let c = this.localBufferNotFilter.length === 0 ? 0 : this.localBufferNotFilter.length
      for (let i = 0; i < c; i++) {
        if (this.localBufferNotFilter[i].id < packageId) {
          minBeforeCurrentIndex = i + 1
        } else {
          break
        }
      }

      this.localBufferNotFilter.splice(minBeforeCurrentIndex, 0, objJointSignalsEcgWithId)

      if (this.localBufferNotFilter.length > 3) {
        this.filteredSignalAndAddToLocalBuffer()
      }

      //Все последующие разы смотрим есть ли следующий пакет и если он есть, то фильтруем его и добавляем в localBuffer
      if (this.localBufferNotFilter && this.localBuffer[0]) {
        while (
          this.localBufferNotFilter.length > 0 &&
          this.localBufferNotFilter[0].id - this.localBuffer[0][this.localBuffer[0].length - 1].id === 1
        ) {
          this.filteredSignalAndAddToLocalBuffer()
        }
      }
    },
    filteredSignalAndAddToLocalBuffer() {
      //Обрыв
      let diffIDLastFilteredPackageAndNext = this.localBuffer[0]
        ? this.localBufferNotFilter[0].id - this.localBuffer[0][this.localBuffer[0].length - 1].id
        : 0
      if (diffIDLastFilteredPackageAndNext > 1) {
        try {
          this.source && this.freeBuffer(this.source)
          this.dest && this.freeBuffer(this.dest)
          this.source = this.allocArray(this.leadscount * this.nbOfSamples)
          this.dest = this.allocArray(this.leadscount * this.nbOfSamples)
          this.indexFilter = this.initFilters(
            this.nbOfSamples * this.leadscount,
            this.leadscount,
            this.nbOfSamples
          )
        } catch {
          cancelAnimationFrame(this.animationId)
          this.canSubscribe = false
          this.$emit('reload:ecg')
        }
      }
      let ecgSignal = []
      let filterJointArr
      try {
        filterJointArr = this.doWasmFilter(this.localBufferNotFilter[0].signals)
      } catch {
        cancelAnimationFrame(this.animationId)
        this.canSubscribe = false
        this.$emit('reload:ecg')
      }

      let filterArrs = []

      let useBitrate = 0
      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        filterArrs[leadNumber] = filterJointArr.slice(useBitrate, useBitrate + this.nbOfSamples)
        useBitrate += this.nbOfSamples
      }
      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        this.setMinMax(leadNumber, filterArrs)

        ecgSignal[leadNumber] = []
        this.localBuffer[leadNumber] = this.localBuffer[leadNumber] ? this.localBuffer[leadNumber] : []
        for (let i = 0; i < filterArrs[leadNumber].length; i++) {
          let b = {
            value: filterArrs[leadNumber][i]
          }
          ecgSignal[leadNumber].push(b)
        }
        let obj = {
          id: this.localBufferNotFilter[0].id,
          data: ecgSignal[leadNumber]
        }
        this.localBuffer[leadNumber].push(obj)
      }
      this.localBufferNotFilter.shift()
    },
    setMinMax(leadNumber, filterArrs) {
      if (!(this.minY[leadNumber] && this.minY[leadNumber] !== 1)) {
        this.minY[leadNumber] = Math.min.apply(null, filterArrs[leadNumber])
      }
      if (!(this.maxY[leadNumber] && this.maxY[leadNumber] !== 1)) {
        this.maxY[leadNumber] = Math.max.apply(null, filterArrs[leadNumber])
        if (!this.maxY.includes(0) && !this.minY.includes(0)) {
          this.createCanvas()
          this.animationId = requestAnimationFrame(this.drawWave)
        }
      }
    },
    calcAndDrawCoordinate() {
      this.drawLoading = true
      let x0, y0
      let coef = this.coefX
      let renderingSpeed =
        this.localBuffer[0].length > 5 ? Math.ceil(6 * (4 / this.coefX)) : Math.ceil(3 * (4 / this.coefX))
      let oldMappedId = this.mappedId
      this.mappedId = this.localBuffer[0][0].id

      while (renderingSpeed !== 0) {
        x0 = this.time * coef * this.scaleX
        this.time = +(this.time + 0.004).toFixed(4)
        let offsetSignal = 40

        for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
          if (this.leadscount > 2 && this.coordinateGraph.length !== this.leadscount) {
            this.coordinateGraph.push(offsetSignal)
          }
          if (this.localBuffer[leadNumber][0].data.length === 0) {
            this.localBuffer[leadNumber].shift()
          }
          y0 = this.getCoordinate(
            this.localBuffer[leadNumber][0].data[0].value,
            this.maxY[leadNumber],
            this.minY[leadNumber],
            offsetSignal
          )
          //407
          if (
            this.$store.getters.AUTH_USER.id === 407 &&
            oldMappedId &&
            this.localBuffer[0][0].id - oldMappedId > 0
          ) {
            this.ctxTime.font = '12px sans'
            this.ctxTime.fillStyle = 'rgba(100, 29, 46, 1)'
            this.ctxTime.fillText(`${this.localBuffer[0][0].id}`, this.time * coef * this.scaleX - 20, 15)
          }
          this.localBuffer[leadNumber][0].data.shift()
          this.drawPoint(x0, y0, leadNumber)

          offsetSignal =
            this.getCoordinate(
              this.minY[leadNumber],
              this.maxY[leadNumber],
              this.minY[leadNumber],
              offsetSignal
            ) +
            this.scaleY * 6
        }
        if (this.time > (this.$el.offsetWidth - 7) / (this.scaleX * this.coefX)) {
          this.time = 0
        }
        renderingSpeed = renderingSpeed - 1
      }
      this.drawLoading = false
    },
    drawWave() {
      this.animationId = requestAnimationFrame(this.drawWave)
      let self = this
      if (self.localBuffer[0] && self.localBuffer[0].length > 2 && this.drawLoading === false) {
        self.calcAndDrawCoordinate()
      }
    },
    doWasmFilter(data) {
      let inArray = new Float32Array(data)
      this.copyToArray(this.source, inArray)
      this.doFilter(this.indexFilter, this.source, this.dest, data.length / this.leadscount)
      let copiedArray = this.ptrToArray(this.dest, data.length)
      return copiedArray
    },
    getCoordinate(sig, max, min, offset) {
      if (max - min == 0) return 1 + offset
      let chartY = (max - min) * 4000 * this.scaleY
      return chartY - (chartY / (max - min)) * (sig - min) + offset
    },
    drawPoint(x0, y0, leadNumber) {
      let x, y
      x = this.lastData[leadNumber] ? this.lastData[leadNumber].x : 0
      y = this.lastData[leadNumber] ? this.lastData[leadNumber].y : 0
      Object.assign(this.lastData, { [leadNumber]: { x: x0, y: y0 } })
      this.ctxEcg.beginPath()
      if (x0 !== 0) {
        this.ctxEcg.moveTo(x, y)
      }
      this.ctxEcg.lineTo(x0, y0)

      this.ctxEcg.stroke()
      this.ctxEcg.clearRect(x0 + 1, 0, 20, this.canvasEcg.height)
      this.ctxTime.clearRect(x0 + 1, 0, 20, this.canvasEcg.height)
    }
  }
}
</script>
